import Box from "@material-ui/core/Box";
import InputAdornment from "@material-ui/core/InputAdornment";
import SvgIcon from "@material-ui/core/SvgIcon";
import {Search as SearchIcon} from "react-feather";
import TextField from "@material-ui/core/TextField";
import React from "react";
import {waitSingleton} from "../../utils/wait";
import {useTranslation} from "react-i18next";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles(() => ({
	search: {
	    marginTop: 16
	}
}));

export const FilterBar = ({children, showQuerySearch = true, showSort = true, sortOptions = [], onFilterChanged, onSortChanged, filter, sort}) => {

	const {t}  = useTranslation();
	const classes = useStyles();

    const onQueryChangedHandler = (event) => {
        waitSingleton(800).then(() => onFilterChanged({ filter : { query: event.target.value }}));
    }

    const onSortChangedHandler = (event) => {
        onSortChanged({ sort: event.target.value })
    }

    return (
      <Box p={2}>
            <Box
              display="flex"
              alignItems="center"
            >
                {showQuerySearch &&
                <Grid item xs={2} className={classes.search}><TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SvgIcon
                        fontSize="small"
                        color="action"
                      >
                        <SearchIcon />
                      </SvgIcon>
                    </InputAdornment>
                  )
                }}
                defaultValue={filter.query}
                onChange={onQueryChangedHandler}
                placeholder={t('Search')}
              /></Grid>}
                {children}
                <Box flexGrow={1} />
              {showSort && <TextField
                label={t("Sort By")}
                name="sort"
                select
                defaultValue={sort}
                onChange={onSortChangedHandler}
                SelectProps={{ native: true }}
              >
                {sortOptions.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
              </TextField>}
            </Box>
      </Box>
    );
}